import {
  CLEAN_OPERATOR_PLUS_GROUP_REQUEST,
  OPERATOR_PLUS_GROUP_FETCH_REQUEST,
  OPERATOR_PLUS_GROUP_FETCH_REQUEST_FAILURE,
  OPERATOR_PLUS_GROUP_FETCH_REQUEST_SUCCESS,
} from 'constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const operatorPlusGroupsDraftDetailsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case OPERATOR_PLUS_GROUP_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case OPERATOR_PLUS_GROUP_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case OPERATOR_PLUS_GROUP_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });
    case CLEAN_OPERATOR_PLUS_GROUP_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default operatorPlusGroupsDraftDetailsReducer;
